import { SingularFaqType, FaqArrayType } from '@appTypes/Faq.interface'

import { StyledFaqText } from '@components/FaqAccordion'

export const preApprovedFaq: SingularFaqType = {
    question: 'What does ‘pre-approved’ mean?',
    answer: (
        <StyledFaqText>
            Pre-approved means you will get accepted for the card, and at the
            rate advertised, providing the information you give is accurate and
            you pass the lender’s checks (which may include a responsible
            lending check using open banking information).
        </StyledFaqText>
    ),
}

export const creditLimitFaq: SingularFaqType = {
    question: 'What’s a credit limit?',
    answer: (
        <StyledFaqText>
            A credit limit represents the maximum amount you can borrow or spend
            on your card, and is set by the lender. It’s based on multiple
            factors, including your credit history and income.
        </StyledFaqText>
    ),
}

export const noGclFaq: SingularFaqType = {
    question: 'Why don’t I have offers with a guaranteed credit limit?',
    answer: (
        <StyledFaqText>
            If you can’t see any offers with a guaranteed credit limit, this is
            because no lenders can offer you a card with the amount you entered.
            You could try decreasing it to see if you get any guaranteed limit
            offers.
        </StyledFaqText>
    ),
}

export const generalScoredQuestions: FaqArrayType = [
    {
        question: 'What is Match Factor?',
        answer: (
            <StyledFaqText>
                Match Factor analyses each product’s features and your
                eligibility, making it easier for you to find the best credit
                product for your situation. We rank our cards based on what we
                think is best for you, not the amount we get paid by a lender.
                Match Factor does not constitute financial advice and you should
                always take the time to understand the credit offers available
                to you.
            </StyledFaqText>
        ),
    },

    preApprovedFaq,

    {
        question: 'What does ‘Variable APR’ mean?',
        answer: (
            <StyledFaqText>
                Variable APR means that the annual percentage rate on your
                credit card can change over time. Most lenders base the variable
                rate on the Bank of England Base Rate, so your rate will change
                automatically in line with changes to the Base Rate. The lender
                will give you notice of any changes.
            </StyledFaqText>
        ),
    },
]
